exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700,800,900&display=swap);", ""]);

// module
exports.push([module.id, ".index__app-wrapper___1mCr_{box-sizing:border-box;min-height:100vh;margin:0;padding:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports
exports.locals = {
	"app-wrapper": "index__app-wrapper___1mCr_"
};